// Which person the People page should select for the id in its address,
// #people/<id>. The global search opens a person that way, and so does the
// "Open staff record" link on Casual Workers.
//
// The decision is by id and nothing else. The search for "anna" also matches
// Hannah, and two people can share a first name, so a name is never a key.
//
// It compares against what is selected now, not against an id the page last
// handled. Remembering the handled id is what broke the sequence of opening
// Tom from search, clicking Amy in the list, then opening Tom from search
// again: the address still said Tom, so the second open was taken as already
// done and Amy stayed selected. The list click now moves the address with the
// selection, so that sequence changes the id, and this rule has no memory to
// go stale.
//
// Returns the id to select, or null to leave the selection alone: nothing
// asked for, already selected (so selecting does not loop), the list not
// loaded yet (the effect runs again when it arrives), or an id matching nobody,
// which shouldClearPerson below then answers.
export function personToSelect(requestedId, selectedId, people) {
  if (requestedId == null || requestedId === '') return null;
  if (requestedId === selectedId) return null;
  if (!Array.isArray(people) || !people.some(p => p.id === requestedId)) return null;
  return requestedId;
}

// Whether the person selected now should be let go because the address no
// longer names them. With Anna open, changing the address to
// #people/does-not-exist must show "Select a person", not leave Anna's panel up
// under an address that says somebody else. The same goes for an address that
// names nobody at all, such as going back to #people from #people/<id>.
//
// An unknown id is only judged once the list has arrived: before that every id
// is unknown, and a refresh of #people/<id> would be cleared before it loaded.
export function shouldClearPerson(requestedId, selectedId, people) {
  if (selectedId == null) return false;
  if (requestedId == null || requestedId === '') return true;
  if (!Array.isArray(people) || people.length === 0) return false;
  return !people.some(p => p.id === requestedId);
}
